import { Component } from '@angular/core'

@Component({
    selector: 'app-p404',
    templateUrl: '404.component.html',
    standalone: false
})
export class P404Component {
    constructor() {}
}
